<app-available-option-modal
  [showAlert]="showAvailableOptionModal"
  (closeModal)="closeActionModal()"
>
</app-available-option-modal>

<app-settings></app-settings>

<div class="container ppl mt-2">
  <div class="columns is-centered">
    <div class="column">
      <div class="columns" *ngIf="(activeTab$ | async) === 'info'">
        <div class="column">
          <app-itinerary-actions
            [noItinerary]="getHasNoItinerary() | async"
            [isReRoute]="noShowRegulationEnabled"
            [actions]="action$ | async"
            [ticketOpen]="pnrInfo?.isOpen"
            [pnr]="pnrInfo"
            [hasPendingChanges]="pnrInfo?.itinerary?.hasPendingChanges"
            [loadingActions]="loadingActions$ | async"
            [selectedPassengersQuote]="selectedPassengersQuote$ | async"
            [selectedSegments]="selectedSegments$ | async"
            [exceptionMode]="exceptionMode$ | async"
            [currentProcess$]="currentProcess$ | async"
            [somePassengerHasTicket]="somePassengerHasTicket$ | async"
            (changeActiveAction)="dispatchActiveAction($event)"
            (optionRequest)="sendOptionRequest($event)"
            (navigateToAction)="confirmAction($event)"
          >
          </app-itinerary-actions>
        </div>
      </div>

      <div class="columns" [class.pt-4]="(activeTab$ | async) !== 'info'">
        <div class="column has-background-white options is-paddingless">
          <app-options
            [pnr]="pnrInfo"
            [searchForm]="searchForm$ | async"
            [activeTab]="activeTab$ | async"
            (navigateTo)="navigateToWithParams($event)"
          ></app-options>
        </div>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
